import PaginatedTabs from './PaginatedTabs';

export default PaginatedTabs;
